import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "@xo-union/tk-css-grid/lib/styles.css";
const Row = _ref => {
  let {
    as: ComponentToRender,
    children,
    className,
    classes: classesProp,
    hAlign,
    hGutters,
    noGutters,
    vAlign,
    vGutters,
    ...props
  } = _ref;
  const classes = useClasses(styles, classesProp);
  const containerClass = cx(className, classes.row, hAlign && styles[`justify-content-${hAlign}`], vAlign && styles[`align-items-${vAlign}`], {
    [styles['no-gutters']]: hGutters === false || noGutters
  }, {
    [styles['vertical-gutters']]: vGutters
  });
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: containerClass
  }, props), children);
};
Row.defaultProps = {
  as: 'div',
  hGutters: true,
  noGutters: false,
  vGutters: false,
  className: ''
};
process.env.NODE_ENV !== "production" ? Row.propTypes = {
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * Class dependencies
   */
  classes: classesPropType(['row']),
  /**
   * Horizontally align columns within the row using flexbox
   */
  hAlign: PropTypes.oneOf(['start', 'center', 'end']),
  /**
   * Horizontal gutters
   */
  hGutters: PropTypes.bool,
  /**
   * @deprecated
   *
   * Deprecated in favor of `hGutters={false}` in v8 (and will be removed in v9). Removes horizontal gutters from a row.
   */
  noGutters: PropTypes.bool,
  /**
   * Vertically align columns within the row using flexbox
   */
  vAlign: PropTypes.oneOf(['start', 'center', 'end']),
  /**
   * Vertical gutters
   */
  vGutters: PropTypes.bool
} : void 0;
export default Row;